module.exports = __webpack_public_path__ + "img/pushover-logo.2082040b.svg";